import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const CommodityColumns = (handleEdit, handleDelete) => {
    return [
        {
            field: 'commodity_code',
            headerName: 'Commodity Code',
            minWidth: 100,
            sortable:true
        },
        {
            field: 'name',
            headerName: 'Commodity Name',
            minWidth: 250,
            sortable:true
        },
        {
            field: 'description',
            headerName: 'Description',
            minWidth: 300,
            flex: 2,
            sortable:true
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            align: 'right',
        
            renderCell: (params) => (
                <div>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </div>
            ),
        },
    ];
};
